var Collapse = {};


//--------------
// Variable
//--------------

Collapse.wrapper = '.js-collapse';
Collapse.button = '.js-collapse-button';
Collapse.content = '.js-collapse-content';


/**
 * Collapse function
 * @return {void}
 */
Collapse.collapsing = function(element) {
	Collapse.$thisWrapper = $(element).closest(Collapse.wrapper);

	if(!Collapse.$thisWrapper.hasClass('is-active')) {
		// Open
		$(Collapse.content).stop().slideUp();
		Collapse.$thisWrapper.find(Collapse.content).stop().slideDown();
		$(Collapse.wrapper).removeClass('is-active');
		Collapse.$thisWrapper.addClass('is-active');
	} else {
		// Close
		$(Collapse.wrapper).removeClass('is-active');
		$(Collapse.content).stop().slideUp();
	}
}


//--------------
// Execution
//--------------

Collapse.init = function(){
	//-- Default Open Collapse
	$(Collapse.wrapper).each(function(){
		if($(this).hasClass('is-active'))
			$(this).find(Collapse.content).slideDown();
	});

	//-- Collapse
	$('body').on('click', Collapse.button, function(){
		Collapse.collapsing(this);
	});

}

Collapse.init();

module.exports = Collapse;
